import React, { useState } from 'react';
import PropTypes from 'prop-types';

import SearchIcon from '../../../images/icons/layout/Search-Blue.svg';
import CloseIcon from '../../../images/icons/layout/Close-Blue.svg';

import { getSearchSuggestions } from '../../../services/search.service';
import goToRedirect from '../../../services/redirect.service';

const SearchBarFeaturedComponent = ({
  title,
  colorScheme,
  searchLinks,
  searchUrl,
  redirectToSearch,
  onSearch,
  microSitePath
}) => {
  // ✅ SAME AS OLD
  const [searchSuggestions, setSearchSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState('');

  const [isOpen, setIsOpen] = useState(false);

  const hasSearchSuggestions = searchSuggestions && searchSuggestions.length;
  const dropdownOpen = hasSearchSuggestions || isOpen;

  const closeDropdown = () => {
    setIsOpen(false);
    setSearchSuggestions([]);
  };

  const closeDropdownClearValue = () => {
    setSearchSuggestions([]);
    setIsOpen(false);
    setInputValue('');
  };

  return (
    <section className={`search-bar-featured search-bar-featured--${colorScheme}`}>
      <div className="container-fluid">
        <div className="search-bar-featured__layout">
          <div className="search-bar-featured__content">
            {title && <h2 className="search-bar-featured__title">{title}</h2>}

            {searchLinks.length > 0 && (
              <div className="search-bar-featured__links">
                <span>E.g. </span>
                {searchLinks.map((link, index) => (
                  <span key={link.url}>
                    <a href={link.url} target={link.target} rel="noreferrer">
                      {link.name}
                    </a>
                    {index + 1 < searchLinks.length && ', '}
                  </span>
                ))}
              </div>
            )}
          </div>

          {/* ✅ OLD input-wrapper logic, NEW classes */}
          <div className="search-bar-featured__search" onBlur={() => closeDropdown()}>
            <form onSubmit={e => e.preventDefault()}>
              <input
                type="text"
                placeholder="Search"
                value={inputValue}
                onChange={async event => {
                  setInputValue(event.target.value);
                  setSearchSuggestions(
                    await getSearchSuggestions(
                      3,
                      event.target.value,
                      true,
                      100,
                      false,
                      microSitePath
                    )
                  );
                }}
              />

              {inputValue && (
                <button
                  type="button"
                  className="search-bar-featured__clear"
                  onClick={() => closeDropdownClearValue()}
                >
                  <img src={CloseIcon} alt="Clear search" />
                </button>
              )}

              <button
                type="submit"
                className="search-bar-featured__submit"
                onClick={() => {
                  if (redirectToSearch) {
                    goToRedirect(searchUrl, 'searchtext', inputValue);
                  } else {
                    closeDropdown();
                    onSearch(inputValue, 1);
                  }
                }}
              >
                <img src={SearchIcon} alt="Search" />
              </button>
            </form>

            {/* ✅ EXACT same dropdown condition as old */}
            {dropdownOpen && (
              <div className="search-bar-featured__dropdown">
                {searchSuggestions.map(item => (
                  <div
                    key={`${item.text}-${item.url}`}
                    className="search-bar-featured__dropdown-item"
                  >
                    {item.url ? (
                      <a href={item.url} onMouseDown={e => e.preventDefault()}>
                        <p dangerouslySetInnerHTML={{ __html: item.text }} />
                        <span className="url">{item.url}</span>
                      </a>
                    ) : (
                      <p dangerouslySetInnerHTML={{ __html: item.text }} />
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

SearchBarFeaturedComponent.propTypes = {
  title: PropTypes.string,
  colorScheme: PropTypes.oneOf(['light', 'dark']).isRequired,
  searchLinks: PropTypes.arrayOf(PropTypes.object),
  searchUrl: PropTypes.string.isRequired,
  redirectToSearch: PropTypes.bool,
  onSearch: PropTypes.func,
  microSitePath: PropTypes.string
};

SearchBarFeaturedComponent.defaultProps = {
  title: '',
  redirectToSearch: true,
  onSearch: () => {},
  searchLinks: [],
  microSitePath: ''
};

export default SearchBarFeaturedComponent;
